export const monetization_type = offer => offer.monetization_type;
export const presentation_type = offer => offer.presentation_type;
export const provider_id = offer => String(offer.provider_id);
export const price = offer => offer.retail_price || 0;
